module.exports = __webpack_public_path__ + "static/media/slack_logo.f074caef.png";